import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../../Config/Config";

export const fetchMediumData = createAsyncThunk("api/medium", async () => {
  const response = await fetch(
    `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-instruction-medium-list`
  );
  const data = await response.json();
  return data;
});

const mediumSlice = createSlice({
  name: "medium",
  initialState: {
    mediumData: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMediumData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMediumData.fulfilled, (state, action) => {
        state.loading = false;
        state.mediumData = action.payload;
      })
      .addCase(fetchMediumData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default mediumSlice.reducer;
